import {useScreen} from 'hooks/useScreen'
import {ReactComponent as ClockIcon} from 'icons/clock.svg'
import moment from 'moment'
import {OrderProvider} from 'providers/OrderProvider'
import {useEffect, useState} from 'react'

export const Timer = () => {
  const order = OrderProvider.useOrder('optional')
  const screen = useScreen()

  const [currentTime, setCurrentTime] = useState(moment())

  useEffect(() => {
    if (!order) {
      return
    }

    const intervalId = setInterval(() => setCurrentTime(moment()), 1000)

    return () => clearInterval(intervalId)
  }, [order])

  if (!order) {
    return null
  }

  return (
    <div className="flex gap-1 rounded-lg font-medium bg-[#FFEACE] items-center py-2 px-6 text-[15px] justify-center">
      <ClockIcon />
      <span>
        Your order is reserved for {moment(moment(order.utcExpiresAt).diff(currentTime)).format('mm:ss')}{' '}
        {screen === 'desktop' ? 'minutes' : 'min'}
      </span>
    </div>
  )
}
